import * as React from 'react';

import { singleton } from 'logic/singleton';

type LogViewLayoutContextValue = {
  timestampField: string;
};
const LogViewLayoutContext = React.createContext<LogViewLayoutContextValue | undefined>(undefined);

export default singleton('contexts.LogViewLayoutContext', () => LogViewLayoutContext);
